import * as am4core from "@amcharts/amcharts4/core";
import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { Routes } from "../app/Routes";
import { I18n } from "../Utils/i18n";
import { LayoutSplashScreen, MaterialThemeProvider } from "../Utils/layout";
import { Tracker } from "./util/analytics";
Tracker.init();

export default function App({ store, persistor, basename }) {
  am4core.addLicense(`${process.env.REACT_APP_AMCHART_LICENSE}`);
  if (process.env.NODE_ENV !== "development") {
    window.sr_version = process.env.REACT_APP_VERSION;
  }
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
        <React.Suspense fallback={<LayoutSplashScreen />}>
          <BrowserRouter basename={basename}>
            <MaterialThemeProvider>
              <I18n>
                <Routes />
              </I18n>
            </MaterialThemeProvider>
          </BrowserRouter>
        </React.Suspense>
      </PersistGate>
    </Provider>
  );
}
